const routerBasePaths = ['/shop/brands', '/shop', '/account', '/westfield-plus', '/membership', ''];
function pathnameMatchesBase(pathname, basePath) {
  return pathname === basePath || pathname.startsWith("".concat(basePath, "/"));
}
export function hrefIsOutsideRouter(routerPathname, href) {
  const a = routerBasePaths.find(bp => pathnameMatchesBase(routerPathname, bp));
  const b = routerBasePaths.find(bp => pathnameMatchesBase(href, bp));
  return a !== b;
}